import { Outlet } from 'react-router-dom'

interface PathGuardProps {
  guard?: JSX.Element
}

export const PathGuard = ({ guard }: PathGuardProps) => {
  return guard ?? <Outlet />
}
